import { getSizedImagePath } from "../lib/utils.js";
import { fetchJson } from "../lib/fetchJson.js";
import { productDisplayTitle } from "../lib/productDisplayTitle.js";

export function showCartSuccessModal(handle: string): void {
  const modal = document.querySelector('#cartAddSuccessModal')
  if (modal instanceof FFCartSuccessModal) {
    modal.init(handle)
  }
}

export class FFCartSuccessModal extends HTMLDialogElement {
  DOM: {
    modalImage: Element | null
    modalTitle: HTMLElement | null
  }

  constructor(){
    super();
    this.DOM = {
      modalImage: this.querySelector('.image'),
      modalTitle: this.querySelector('.title'),
    }
    this.addEventListener("click", () => this.close())
  }

  async init( handle: string ){
    try {
      const product = await fetchJson<{ featured_image?: string, title?: string }>(`/products/${handle}.js`, { method: 'GET' })
      let metafields: { display_title?: string } | undefined
      try {
        metafields = await fetchJson<{ display_title?: string }>(`/products/${handle}?view=metafield`, { method: 'GET' })
      } catch {
        metafields = undefined
      }

      this.DOM.modalImage!.innerHTML = '';
      let src = product.featured_image;
      if( src ){
        src = getSizedImagePath( src, '600x600');
        const productImage = document.createElement('img');
        productImage.src = src || "";
        this.DOM.modalImage!.appendChild( productImage );
      }
      this.DOM.modalTitle!.innerText = productDisplayTitle(product.title || "", metafields);
      super.showModal();
    } catch (_error) {
      // DOM parsing only; no user-facing recovery needed
    }
	}
}
customElements.define('ff-cart-success-modal', FFCartSuccessModal, { extends: 'dialog' });